import React, { useEffect, useState } from 'react';
import './ButonInstallAppNav.css';

const ButonInstallAppNav = ({ label = 'Descargar App', className = '' }) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isIos, setIsIos] = useState(false);
    const [isStandalone, setIsStandalone] = useState(false);
    const [isMobileDevice, setIsMobileDevice] = useState(false);

    useEffect(() => {
        const userAgent = window.navigator.userAgent || '';
        const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

        setIsStandalone(standalone);
        setIsIos(/iphone|ipad|ipod/i.test(userAgent));
        setIsMobileDevice(/android|iphone|ipad|ipod|mobile/i.test(userAgent));

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        if (!isMobileDevice && !isIos) {
            window.alert('Descarga la App desde tu teléfono móvil.');
            return;
        }

        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => {
                setDeferredPrompt(null);
            });
            return;
        }

        if (isIos) {
            window.alert('En iPhone o iPad, abre este sitio en Safari, toca Compartir y luego "Agregar a pantalla de inicio".');
            return;
        }

        window.alert('La instalación no está disponible todavía en este navegador. Prueba abrir la tienda desde Chrome en Android o Safari en iPhone.');
    };

    if (isStandalone) {
        return null;
    }

    return (
        <button onClick={handleInstallClick} className={`btnInstall ${className}`.trim()}>
            {label}
        </button>
    );
};

export default ButonInstallAppNav;
